import { render, staticRenderFns } from "./GridTraspaso.vue?vue&type=template&id=642b781a&"
import script from "./GridTraspaso.vue?vue&type=script&lang=js&"
export * from "./GridTraspaso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports